<script lang="js" setup></script>

<template>
  <div
    class="py-8 md:py-10 xl:py-14 flex flex-col gap-y-8 md:gap-y-10 xl:gap-y-14 2xl:max-w-screen-2xl max-w-screen-xl mx-auto"
  >
    <h4 class="text-center text-lg md:text-xl xl:text-2xl font-bold">
      Our Clients Have Been Featured In
    </h4>
    <div
      class="logos-container flex items-center justify-center gap-x-2 sm:gap-x-4 md:gap-x-8 xl:gap-x-12 overflow-hidden"
    >
      <img
        class="h-6 sm:h-8 md:h-10 xl:h-12 flex-shrink-0"
        src="@/assets/logos/logo1.png"
        alt="logo 1"
      />
      <img
        class="h-6 sm:h-8 md:h-10 xl:h-12 flex-shrink-0"
        src="@/assets/logos/logo2.png"
        alt="logo 2"
      />
      <img
        class="h-6 sm:h-8 md:h-10 xl:h-12 flex-shrink-0"
        src="@/assets/logos/logo3.png"
        alt="logo 3"
      />
      <img
        class="h-6 sm:h-8 md:h-10 xl:h-12 flex-shrink-0"
        src="@/assets/logos/logo4.png"
        alt="logo 4"
      />
      <img
        class="h-6 sm:h-8 md:h-10 xl:h-12 flex-shrink-0 hidden sm:block"
        src="@/assets/logos/logo1.png"
        alt="logo 1"
      />
      <img
        class="h-6 sm:h-8 md:h-10 xl:h-12 flex-shrink-0 hidden md:block"
        src="@/assets/logos/logo2.png"
        alt="logo 2"
      />
    </div>
  </div>
</template>
<style scoped>
.logos-container {
  mask: linear-gradient(
    to right,
    transparent 0%,
    black 25%,
    black 75%,
    transparent 100%
  );
  -webkit-mask: linear-gradient(
    to right,
    transparent 0%,
    black 25%,
    black 75%,
    transparent 100%
  );
}
</style>
